import { SliderTooltipNotch } from "../../SliderBase";

const sort = (notches: SliderTooltipNotch[]): SliderTooltipNotch[] =>
  notches.sort((a, b) => {
    const startValueComparison = a.startValue - b.startValue;
    return startValueComparison !== 0
      ? startValueComparison
      : a.tooltip.localeCompare(b.tooltip);
  });

const makeRangeSafe = (
  sortedTooltipNotches: SliderTooltipNotch[],
  minValue: number,
  maxValue: number
): SliderTooltipNotch[] =>
  sortedTooltipNotches.filter(
    (notch) => notch.startValue >= minValue && notch.startValue <= maxValue
  );

const removeDuplicates = (
  sortedTooltipNotches: SliderTooltipNotch[]
): SliderTooltipNotch[] => {
  const seen: { [key: string]: boolean } = {};
  const unique: SliderTooltipNotch[] = [];

  sortedTooltipNotches.forEach((notch) => {
    // handles weird storybook bug with interpolation in object keys
    // https://github.com/reactjs/react-docgen/issues/876
    const stringKey = `${notch.startValue}`;
    if (!seen[stringKey]) {
      seen[stringKey] = true;
      unique.push(notch);
    }
  });

  return unique;
};

export const safeTooltipNotches = (
  minValue: number,
  maxValue: number,
  tooltipNotches: SliderTooltipNotch[]
): SliderTooltipNotch[] | undefined => {
  if (!tooltipNotches || !tooltipNotches.length) return undefined;

  const sorted = sort(tooltipNotches);
  const rangeSafe = makeRangeSafe(sorted, minValue, maxValue);
  const unique = removeDuplicates(rangeSafe);

  if (unique.length < rangeSafe.length)
    console.warn("duplicate notches have been discovered");

  return unique;
};
